import { Grid } from "@mui/material";
import SideBar from "../SideBar";

const PageLayout = ({ children }) => (
  <Grid container>
    <Grid item md={2} xs={2}>
      <SideBar />
    </Grid>
    <Grid item md={10} xs={10}>
      {children}
    </Grid>
  </Grid>
);

export default PageLayout;
